import yup from 'utils/yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useModal } from 'ui/components/screens/modals/useModal';

const schema = yup
    .object({
        meeting_date: yup
            .string()
            .default('')
            .test('isDate', '日付の形式が正しくありません', function (value) {
                if (!value) {
                    return true;
                }

                return value.match(/^\d{4}\/\d{1,2}\/\d{1,2} \d{2}:\d{2}$/) !== null;
            })
            .required(),
    })
    .required();

type SetMeetingForm = yup.InferType<typeof schema>;

export const useSetMeeting = () => {
    const setMeetingModal = useModal();
    const { openModal, createModal, closeModal } = setMeetingModal;

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<SetMeetingForm>({
        resolver: yupResolver(schema),
        mode: 'onChange',
    });
    return {
        control,
        errors,
        handleSubmit,
        openModal,
        createModal,
        closeModal,
    };
};
